module.exports = __webpack_public_path__ + "img/637693d.png";